import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const pickTicketsSubNav: RouteListItem[] = [
  {
    path: '/pick-tickets/$id',
    icon: UserCircle,
    name: 'Pick Ticket',
  },
];
